import classNames from 'classnames';
import { InputHTMLAttributes, LegacyRef, forwardRef } from 'react';
import InputMask, { ReactInputMask, Props as ReactInputMaskProps } from 'react-input-mask';

import s from './Input.module.css';

type Props = (InputHTMLAttributes<HTMLInputElement> & { mask?: never }) | ReactInputMaskProps;

const Input = ({ className, mask, ...rest }: Props, ref: LegacyRef<HTMLInputElement>) => {
  if (mask) {
    return (
      <InputMask
        className={classNames(s.control, className)}
        {...rest}
        ref={ref as LegacyRef<ReactInputMask>}
        mask={mask}
        maskPlaceholder=""
      />
    );
  }
  return <input className={classNames(s.control, className)} {...rest} ref={ref} />;
};

export default forwardRef(Input);
